export const prepareUpdateFields = (
  dto: any,
  relationMap?: { [key: string]: string },
): any => {
  const fields: any = {};

  Object.entries(dto).forEach(([key, value]) => {
    if (value !== undefined && key !== 'id') {
      if (relationMap && relationMap[key]) {
        // Map to relation entity for TypeORM
        fields[relationMap[key]] = { id: value };
      } else {
        // normal field
        const column = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        fields[column] = value;
      }
    }
  });

  return fields;
};